export const mockedSuvs = [
  {
    carlineId: '31692',
    description: 'Sporty cross coupe',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/ACS.jpg',
    showIIHSLogo: "true",
    IIHSImagePath: "/content/dam/onehub_pkw/importers/us/en/modelscarousel/IIHSLogo.png"
  },
  {
    carlineId: '31691',
    description: 'Spacious family SUV',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/Atlas.jpg',
    showIIHSLogo: "true",
    IIHSImagePath: "/content/dam/onehub_pkw/importers/us/en/modelscarousel/IIHSLogo.png",
    showConsumerReportsLogo: "true"
  },
  {
    carlineId: '30291',
    description: 'Stylish electric SUV',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/ID4.jpg'
  },
  {
    carlineId: '31150',
    description: 'Compact family SUV',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/Tiguan.jpg',
    showConsumerReportsLogo: "true"
  },
  {
    carlineId: '30385',
    description: 'Versatile compact SUV',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/Taos.jpg'
  }
];

export const mockedSedans = [
  {
    carlineId: '30906',
    description: 'Classic sedan style',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/Jetta.jpg'
  },
  {
    carlineId: '30907',
    description: 'Sporty performance sedan',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/GLI.jpg'
  },
  {
    carlineId: '30310',
    description: 'High-performance hatch',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/GolfR.jpg'
  },
];

export const mockedCompacts = [
  {
    carlineId: '30310',
    description: 'High-performance hatch',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/GolfR.jpg'
  },
  {
    carlineId: '30320',
    description: 'Dynamic compact hatch',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/GTI.jpg'
  },
];

export const mockedElectricVehicles = [
  {
    carlineId: '72006',
    description: 'Retro electric bus',
    backgroundImage: '/content/dam/onehub_pkw/importers/us/en/modelscarousel/Buzz.jpg'
  },
];
